import React from 'react'
import styled from '@emotion/styled'
import Link from 'next/link'
import { Block, BlockHeader } from '../Block'
import { createMarkup, getLinkProps } from '../../utils'
import {
  color,
  H2,
  H4,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  Text,
  BaseButton,
} from '@ticketswap/solar'

const StyledAccordionItem = styled(AccordionItem)`
  &:first-of-type {
    border-top: 0;
  }
  &:last-of-type {
    border-bottom: 0;
  }
`

const Label = styled(H4)`
  font-weight: normal;
`

const StyledText = styled(Text)`
  color: ${color.spaceMedium};
`

function ListingFaq({ t, ...props }) {
  const options = { renderInline: true }
  const items = props.showSecureSwapFaq
    ? ['alphaAlt', 'beta', 'gamma', 'delta']
    : ['alpha', 'beta', 'gamma', 'delta']

  return (
    <Block>
      <BlockHeader>
        <H2>{t('listing:faq.title')}</H2>
      </BlockHeader>

      <Accordion collapsible>
        {items.map(item => (
          <StyledAccordionItem key={item}>
            <AccordionButton>
              <Label
                as="span"
                dangerouslySetInnerHTML={createMarkup(
                  t(`listing:faq.${item}.title`),
                  options
                )}
              />
            </AccordionButton>
            <AccordionPanel>
              <StyledText
                as="p"
                dangerouslySetInnerHTML={createMarkup(
                  t(`listing:faq.${item}.text`),
                  options
                )}
              />

              {item === 'delta' && (
                <Link {...getLinkProps('HELP')} passHref>
                  <BaseButton as="a">{t('listing:faq.button')}</BaseButton>
                </Link>
              )}
            </AccordionPanel>
          </StyledAccordionItem>
        ))}
      </Accordion>
    </Block>
  )
}

export default ListingFaq
